document.addEventListener("DOMContentLoaded", async function () {
  const dtf_add_to_cart = document.getElementById("dtf-add-to-cart");
  const designsContainer = document.getElementById("designs-container");
  const addAnotherDesignInput = document.getElementById(
    "add-another-design-input"
  );

  // ============================================================
  // MULTI-DESIGN STATE
  // Each design represents one uploaded artwork. The user can
  // add/remove multiple designs; volume discount applies per design
  // (each design's own quantity). Cart total sums all design line totals.
  // ============================================================
  const designs = [];
  let nextDesignId = 1;
  // Tracks the design whose image is currently shown in the mockup.
  // Updated only when the user uploads a new design or manually expands one.
  // Collapsing a card never changes this — the mockup keeps showing the last touched design.
  let lastActiveDesign = null;

  // Discount tiers: discount applies on the COMBINED qty across designs.
  // Matches the discount-guide-modal table.
  const FREE_SHIP_THRESHOLD = 25;

  const DTF_PCS_CART_BTN_HTML = `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.4 12.4a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L23 6H6"/></svg><span class="dtf-pcs-btn__text">Add to cart</span>`;

  const DTF_PCS_CART_LOADING_HTML = `<span class="dtf-pcs-cart-loading"><svg class="dtf-pcs-cart-loading__icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-6.22-8.56"/></svg>Adding to cart</span>`;

  const DISCOUNT_TIERS = [
    { min: 0, discount: 0 },
    { min: 15, discount: 0.2 },
    { min: 50, discount: 0.3 },
    { min: 100, discount: 0.4 },
    { min: 250, discount: 0.5 },
  ];

  const VOLUME_DISCOUNT_PANEL_HTML = `
      <div class="volume-discount-panel expand-only">
        <div class="vd-head">
          <div class="vd-head-info">
            <h4>Volume Discounts</h4>
            <p class="vd-subtitle">Automatically applied. The more you order, the less you pay per sheet.</p>
          </div>
          <div class="vd-head-actions">
            <span class="vd-discount-badge" hidden></span>
            <button type="button" class="vd-guide-link">View Guide</button>
          </div>
        </div>
        <div class="vd-tiers">
          <div class="vd-tier" data-min="15"><strong>20%</strong><span>15+ pcs</span></div>
          <div class="vd-tier" data-min="50"><strong>30%</strong><span>50+ pcs</span></div>
          <div class="vd-tier" data-min="100"><strong>40%</strong><span>100+ pcs</span></div>
          <div class="vd-tier" data-min="250"><strong>50%</strong><span>250+ pcs</span></div>
        </div>
        <div class="vd-progress-track">
          <div class="vd-progress-fill"></div>
        </div>
        <p class="vd-progress-message"></p>
      </div>`;

  // Hard product limits — DTF transfer max physical size.
  const MAX_W_IN = 28;
  const MAX_H_IN = 100;

  // Categorised popular sizes (fixed, shown in the Popular Sizes view).
  const POPULAR_SIZES_CATEGORIES = [
    {
      id: "small",
      title: "Small Prints",
      subtitle: "Pocket logos, left chest",
      sizes: [
        { w: 2, h: 2 },
        { w: 3, h: 3 },
        { w: 4, h: 2 },
        { w: 4, h: 4 },
        { w: 5, h: 3 },
      ],
    },
    {
      id: "medium",
      title: "Medium Prints",
      subtitle: "Youth / chest prints",
      sizes: [
        { w: 5, h: 5 },
        { w: 6, h: 4 },
        { w: 6, h: 6 },
        { w: 7, h: 7 },
        { w: 8, h: 8 },
      ],
    },
    {
      id: "large",
      title: "Large Prints",
      subtitle: "Full front / back",
      sizes: [
        { w: 9, h: 9 },
        { w: 9, h: 11 },
        { w: 10, h: 10 },
        { w: 11, h: 5 },
        { w: 11, h: 11 },
        { w: 4, h: 14 },
        { w: 12, h: 14 },
        { w: 12, h: 17 },
      ],
    },
  ];

  // Tailored size tiers — generated per-design using image's aspect ratio.
  // Each tier defines target "max-dimension" levels; for each level the
  // shorter side is computed from the aspect ratio so the suggestion
  // always preserves the image proportions.
  const TAILORED_TIERS = [
    {
      id: "small",
      title: "Small",
      subtitle: "Hat logos, tags, labels",
      maxDims: [1.5, 2, 2.5, 3, 3.5, 4],
    },
    {
      id: "medium",
      title: "Medium",
      subtitle: "Chest prints, youth tees",
      maxDims: [5, 6, 7, 8],
    },
    {
      id: "large",
      title: "Large",
      subtitle: "Full front, back, oversized",
      maxDims: [9, 10, 11, 12, 14, 16, 18, 20],
    },
  ];

  function clampWH(w, h) {
    if (w > MAX_W_IN) {
      const f = MAX_W_IN / w;
      w = MAX_W_IN;
      h = h * f;
    }
    if (h > MAX_H_IN) {
      const f = MAX_H_IN / h;
      h = MAX_H_IN;
      w = w * f;
    }
    return { w, h };
  }

  function buildTailoredSizes(aspectRatio) {
    return TAILORED_TIERS
      .map((tier) => ({
        ...tier,
        sizes: tier.maxDims
          .map((maxDim) => {
            let w, h;
            if (aspectRatio >= 1) {
              w = maxDim;
              h = maxDim / aspectRatio;
            } else {
              h = maxDim;
              w = maxDim * aspectRatio;
            }
            const c = clampWH(w, h);
            return {
              w: parseFloat(c.w.toFixed(2)),
              h: parseFloat(c.h.toFixed(2)),
            };
          })
          .filter((s) => s.w >= 0.5 && s.h >= 0.5)
          // Drop duplicates that collapsed onto each other after clamping.
          .filter(
            (s, i, arr) =>
              i === 0 || s.w !== arr[i - 1].w || s.h !== arr[i - 1].h
          ),
      }))
      .filter((t) => t.sizes.length > 0);
  }

  function getPrintDpi(design, w, h) {
    if (!design.pixelWidth || !design.pixelHeight || !w || !h) return Infinity;
    return Math.min(design.pixelWidth / w, design.pixelHeight / h);
  }

  // Closest popular tile to (w, h) using Manhattan distance — used to
  // pre-select a sensible popular size right after upload.
  function findClosestPopular(w, h) {
    let best = null;
    let bestDist = Infinity;
    for (const cat of POPULAR_SIZES_CATEGORIES) {
      for (const s of cat.sizes) {
        const d = Math.abs(s.w - w) + Math.abs(s.h - h);
        if (d < bestDist) {
          bestDist = d;
          best = s;
        }
      }
    }
    return best || { w: 4, h: 4 };
  }

  // Print-DPI quality classification, used by the design-card header
  // badge and to decide whether to show the conditional "Best Fit For
  // Your Design" card. Tiers chosen to match common DTF / industry
  // recommendations:
  //   HD       : 200+ DPI (sharp, photo-grade)
  //   Standard : 100-199 DPI (acceptable for most prints)
  //   Low Res  : < 100 DPI (visibly soft / pixelated)
  // `cls` aliases to the existing `.dpi-badge.{low,medium,high}` styles
  // already defined for the header badge so we don't need new CSS.
  function getPrintDpiInfo(dpi) {
    if (!isFinite(dpi))
      return { tier: "hd", label: "HD", dpi: 0, cls: "high", icon: "✓" };
    const rounded = Math.round(dpi);
    if (dpi >= 200)
      return { tier: "hd", label: "HD", dpi: rounded, cls: "high", icon: "✓" };
    if (dpi >= 100)
      return {
        tier: "standard",
        label: "Standard",
        dpi: rounded,
        cls: "medium",
        icon: "✓",
      };
    return {
      tier: "low",
      label: "Low Res",
      dpi: rounded,
      cls: "low",
      icon: "⚠",
    };
  }

  function isLowResAtSize(design, w, h) {
    return getPrintDpi(design, w, h) < 100;
  }

  // Round UP to the next 0.5" step. We use a tiny epsilon so values that
  // are already an exact multiple of 0.5 (like 2.0) don't get bumped to
  // 2.5 by floating-point drift.
  function ceilToHalfInch(value) {
    const eps = 1e-6;
    return Math.ceil(value / 0.5 - eps) * 0.5;
  }

  // -------------------------------------------------------------
  // BEST-FIT SUGGESTION (preserve-width, preset-price gated)
  // -------------------------------------------------------------
  //   1. Keep the user's chosen WIDTH untouched
  //   2. Compute the proportionally-correct height at that width
  //   3. Round it UP to the next 0.5" so the image still fits inside
  //   4. Match against the smallest popular preset that contains the
  //      (W, idealH) box, purely for the price comparison
  //   5. Surface the suggestion only when:
  //        a. matched-preset price >= current selection's price, AND
  //        b. the height change is meaningful (>= 0.3")
  //
  // Returning null hides the "Best Fit" card.

  // Smallest popular preset (by area) that contains both `idealW` and
  // `idealH`. Used for the "no-downgrade" price comparison.
  function findClosestContainingPreset(idealW, idealH) {
    const eps = 0.001;
    let best = null;
    let bestArea = Infinity;
    for (const cat of POPULAR_SIZES_CATEGORIES) {
      for (const s of cat.sizes) {
        if (s.w >= idealW - eps && s.h >= idealH - eps) {
          const area = s.w * s.h;
          if (area < bestArea) {
            bestArea = area;
            best = s;
          }
        }
      }
    }
    return best;
  }

  // True when (w, h) is an EXACT match for one of the popular preset
  // tiles. We use this to suppress the "Best Fit" card whenever the
  // suggestion is already a single tap away in the Popular grid — no
  // need to surface a redundant CTA.
  function isExactPopularSize(w, h) {
    const eps = 0.01;
    for (const cat of POPULAR_SIZES_CATEGORIES) {
      for (const s of cat.sizes) {
        if (Math.abs(s.w - w) < eps && Math.abs(s.h - h) < eps) return true;
      }
    }
    return false;
  }

  function computeBestFitForSize(design, currentW, currentH) {
    if (!design || !design.pixelWidth || !design.pixelHeight) return null;
    if (!currentW || currentW <= 0 || !currentH || currentH <= 0) return null;

    // Preserve the user's chosen width; the height is the only knob.
    const ratio = design.pixelHeight / design.pixelWidth;
    let idealH = ceilToHalfInch(currentW * ratio);
    idealH = Math.max(0.5, Math.min(MAX_H_IN, idealH));

    // Negligible change — current pick is already (close to) the
    // proportionally-correct height.
    if (Math.abs(idealH - currentH) < 0.3) return null;

    // Skip when the ideal size IS a popular tile already — the user
    // can pick it with a single tap, so the bf-card would be redundant
    // (e.g. 11×5 with a 1:1 image → ideal 11×11, which is right there
    // in the Large Prints row).
    if (isExactPopularSize(currentW, idealH)) return null;

    // Match against popular presets to compare prices.
    const matched = findClosestContainingPreset(currentW, idealH);
    if (!matched) return null;

    const idealPrice = findBasePrice(matched.w * matched.h);
    const currentPrice = findBasePrice(currentW * currentH);

    // Don't surface a cheaper alternative (no revenue downgrade).
    if (idealPrice < currentPrice) return null;

    return {
      w: parseFloat(currentW.toFixed(2)),
      h: parseFloat(idealH.toFixed(2)),
    };
  }

  // Per-garment mockup configuration.
  // cx / cy        = center of the print zone as % of the garment image (H × V).
  // maxPrintW      = max printable width in inches on that garment.
  // printWidthPct  = what percentage of the rendered image width that maxPrintW fills.
  // centerArea     = sq-in threshold above which we use Center Print instead of Left Chest.
  // Per-garment mockup configuration.
  // printWidthPct = the % of the RENDERED garment-image width (after object-fit:contain
  // letterboxing) that the maximum printable area spans.  Garment images are portrait
  // so they are narrower than the container; this value accounts for that.
  // Rule of thumb: keep printWidthPct ≈ (maxPrintW / physicalShirtWidth) × shirtFillPct
  // where shirtFillPct ≈ 58-65% for portrait shirt photos in a square container.
  const GARMENT_CONFIGS = {
    tshirt: {
      label: "T-Shirt",
      iconSvg: `<svg class="garment-tab-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3L3 7v3h3v11h12V10h3V7l-3-4h-3l-2 3h-2L9 3H6z"/></svg>`,
      img: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/shirt2.webp",
      maxPrintW: 12,
      printWidthPct: 33,   // ~56 / 1.7 — shirt fills ≈60% of container after letterbox
      leftChest: { cx: 37, cy: 37 },
      center: { cx: 50, cy: 48 },
      centerArea: 15,
    },
    hoodie: {
      label: "Hoodie",
      iconSvg: `<svg class="garment-tab-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2L8 5v3H6L3 9v13h18V9l-3-3h-2V5l-4-3z"/><path d="M9 11c0 2 1.5 4 3 4s3-2 3-4"/></svg>`,
      img: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/hoodie2.webp",
      maxPrintW: 11,
      printWidthPct: 31,
      leftChest: { cx: 37, cy: 43 },
      center: { cx: 50, cy: 53 },
      centerArea: 15,
    },
    // apron: {
    //   label: "Apron",
    //   img: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/apron2.webp",
    //   maxPrintW: 9,
    //   printWidthPct: 25,
    //   leftChest: { cx: 39, cy: 37 },
    //   center: { cx: 50, cy: 52 },
    //   centerArea: 15,
    // },
    tote: {
      label: "Tote",
      iconSvg: `<svg class="garment-tab-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l-1.2 11H7.2L6 8z"/><path d="M9 8V6a3 3 0 016 0v2"/></svg>`,
      img: "https://cdn.shopify.com/s/files/1/0582/5400/0176/files/bag2.webp",
      maxPrintW: 10,
      printWidthPct: 30,
      leftChest: null,
      center: { cx: 50, cy: 56 },
      centerArea: 0, // always center for tote
    },
  };

  const dtfThumbnailHTML = `
<div class="dtf-thumbnail" id="dtf-thumbnail">
  <div class="mockup-topbar">
    <div class="garment-tabs" id="garment-tabs">
      ${Object.entries(GARMENT_CONFIGS)
      .map(([k, g], i) =>
        `<button type="button" class="garment-tab${i === 0 ? " active" : ""}" data-garment="${k}" aria-label="${g.label}">
          <span class="garment-tab-icon-wrap">${g.iconSvg}</span>
          <span class="garment-tab-label">${g.label}</span>
        </button>`
      )
      .join("")}
      </div>
    </div>
  <div class="mockup-panels" id="mockup-panels">
    ${Object.entries(GARMENT_CONFIGS)
      .map(
        ([k, g], i) => `
    <div class="mockup-panel${i === 0 ? " active" : ""}" data-garment="${k}" id="mockup-panel-${k}">
      <div class="mockup-wrap" id="mockup-wrap-${k}">
        <img class="mockup-garment-img" src="${g.img}" alt="${g.label}" />
        <div class="mockup-design-overlay" id="mockup-overlay-${k}">
          <img class="mockup-blob-img" id="mockup-blob-${k}" src="" alt="Design preview" />
          <div class="mdim-bottom"><span></span></div>
          <div class="mdim-left"><span></span></div>
      </div>
    </div>
    </div>`
      )
      .join("")}
  </div>
  <div class="mockup-info-bar" id="mockup-info-bar">
    <span class="mockup-position-pill" id="mockup-position-label"></span>
    <span class="mockup-dim-text" id="mockup-size-label"></span>
    <span class="mockup-fill-text" id="mockup-fill-label"></span>
    <div class="dtf-color-selector" id="dtf-color-selector">
    <span class="active" data-color="#f5f5f5"></span>
      <span data-color="#1a1a1a"></span>
      <span data-color="#2c4a8c"></span>
      <span data-color="#888888"></span>
      <span data-color="#c0392b"></span>
    <span class="custom-color-trigger" data-color="custom">
      <div class="custom-color-icon"></div>
      <div class="color-picker-container hidden" id="color-picker-container">
        <div id="color-picker"></div>
      </div>
    </span>
    </div>
  </div>
</div>`;

  // Mockup garment colors that match the first two swatches (#f5f5f5 light, #1a1a1a dark).
  const MOCKUP_LIGHT_HEX = "#f5f5f5";
  const MOCKUP_DARK_HEX = "#1a1a1a";

  /** Sync mockup panel + swatch UI to light/dark fabric preset colors. */
  function applyMockupColorForFabric(fabric) {
    const sel = document.getElementById("dtf-color-selector");
    if (!sel) return;
    const hex = fabric === "Dark Fabric" ? MOCKUP_DARK_HEX : MOCKUP_LIGHT_HEX;
    const target = sel.querySelector(`span[data-color="${hex}"]`);
    if (!target || target.classList.contains("custom-color-trigger")) return;
    sel.querySelectorAll("span").forEach((item) => item.classList.remove("active"));
    target.classList.add("active");
    document.querySelectorAll(".mockup-panel").forEach((p) => {
      p.style.background = hex;
    });
    const picker = document.getElementById("color-picker-container");
    if (picker) picker.classList.add("hidden");
  }

  // ============================================================
  // PRICING UTILITIES
  // ============================================================
  function animatePriceChange(targetElement, start, end, duration = 500) {
    let startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = start + (end - start) * progress;
      targetElement.textContent = currentValue.toFixed(2);
      if (progress < 1) requestAnimationFrame(step);
      }
    requestAnimationFrame(step);
  }

  function findBasePrice(area) {
    const styleRanges = [
      { min: 1, max: 9, price: 0.37 },
      { min: 10, max: 19, price: 1.09 },
      { min: 20, max: 29, price: 1.9 },
      { min: 30, max: 39, price: 2.28 },
      { min: 40, max: 49, price: 3.33 },
      { min: 50, max: 59, price: 3.96 },
      { min: 60, max: 69, price: 4.28 },
      { min: 70, max: 79, price: 5.43 },
      { min: 80, max: 89, price: 5.81 },
      { min: 90, max: 99, price: 6.34 },
      { min: 100, max: 109, price: 7.39 },
      { min: 110, max: 119, price: 8.12 },
      { min: 120, max: 129, price: 8.65 },
      { min: 130, max: 139, price: 9.17 },
      { min: 140, max: 149, price: 9.7 },
      { min: 150, max: 159, price: 10.01 },
      { min: 160, max: 169, price: 10.26 },
      { min: 170, max: 179, price: 10.79 },
      { min: 180, max: 189, price: 11.31 },
      { min: 190, max: 199, price: 11.84 },
      { min: 200, max: 209, price: 12.36 },
      { min: 210, max: 219, price: 12.89 },
      { min: 220, max: 229, price: 13.41 },
      { min: 230, max: 239, price: 13.94 },
      { min: 240, max: 249, price: 14.46 },
      { min: 250, max: 259, price: 14.99 },
      { min: 260, max: 269, price: 15.51 },
      { min: 270, max: 279, price: 16.04 },
      { min: 280, max: 309, price: 16.56 },
      { min: 310, max: 349, price: 17.09 },
      { min: 350, max: 389, price: 17.61 },
      { min: 390, max: 429, price: 18.14 },
      { min: 430, max: 469, price: 18.66 },
      { min: 470, max: 509, price: 19.19 },
      { min: 510, max: 549, price: 19.72 },
      { min: 550, max: 589, price: 20.24 },
      { min: 590, max: 629, price: 20.77 },
      { min: 630, max: 669, price: 21.29 },
      { min: 670, max: 709, price: 21.82 },
      { min: 710, max: 749, price: 22.34 },
      { min: 750, max: 789, price: 22.87 },
      { min: 790, max: 829, price: 23.39 },
      { min: 830, max: 869, price: 23.92 },
      { min: 870, max: 909, price: 24.44 },
      { min: 910, max: 949, price: 24.97 },
      { min: 950, max: 989, price: 25.49 },
      { min: 990, max: 1029, price: 26.02 },
      { min: 1030, max: 1069, price: 26.54 },
      { min: 1070, max: 1109, price: 27.07 },
      { min: 1110, max: 1149, price: 27.59 },
      { min: 1150, max: 1189, price: 28.12 },
      { min: 1190, max: 1229, price: 28.64 },
      { min: 1230, max: 1269, price: 29.17 },
      { min: 1270, max: 1309, price: 29.69 },
      { min: 1310, max: 1349, price: 30.22 },
      { min: 1350, max: 1389, price: 30.74 },
      { min: 1390, max: 1429, price: 31.27 },
      { min: 1430, max: 1469, price: 31.79 },
      { min: 1470, max: 1509, price: 32.32 },
      { min: 1510, max: 1549, price: 32.84 },
      { min: 1550, max: 1589, price: 33.37 },
      { min: 1590, max: 1629, price: 33.89 },
      { min: 1630, max: 1669, price: 34.42 },
      { min: 1670, max: 1709, price: 34.94 },
      { min: 1710, max: 1749, price: 35.47 },
      { min: 1750, max: 1789, price: 35.99 },
      { min: 1790, max: 1829, price: 36.52 },
      { min: 1830, max: 1869, price: 37.04 },
      { min: 1870, max: 1909, price: 37.57 },
      { min: 1910, max: 1949, price: 38.09 },
      { min: 1950, max: 1989, price: 38.62 },
      { min: 1990, max: 2029, price: 39.14 },
      { min: 2030, max: 2069, price: 39.67 },
      { min: 2070, max: 2109, price: 40.19 },
      { min: 2110, max: 2149, price: 40.72 },
      { min: 2150, max: 2189, price: 41.24 },
      { min: 2190, max: 2229, price: 41.77 },
      { min: 2230, max: 2269, price: 42.29 },
      { min: 2270, max: 2309, price: 42.82 },
      { min: 2310, max: 2349, price: 43.34 },
      { min: 2350, max: 2389, price: 43.87 },
      { min: 2390, max: 2429, price: 44.39 },
      { min: 2430, max: 2469, price: 44.92 },
      { min: 2470, max: 2509, price: 45.44 },
      { min: 2510, max: 2549, price: 45.97 },
      { min: 2550, max: 2589, price: 46.49 },
      { min: 2590, max: 2629, price: 47.02 },
      { min: 2630, max: 2669, price: 47.54 },
      { min: 2670, max: 2709, price: 48.07 },
      { min: 2710, max: 2749, price: 48.59 },
      { min: 2750, max: 2789, price: 49.12 },
      { min: 2790, max: 2800, price: 49.64 },
    ];
    const flooredArea = Math.floor(area);
    const match = styleRanges.find(
      (r) => flooredArea >= r.min && flooredArea <= r.max
    );
    return match ? match.price : 0;
  }

  function calculateDiscountByQty(qty) {
    let discount = 0;
    for (const tier of DISCOUNT_TIERS) {
      if (qty >= tier.min) discount = tier.discount;
    }
    return discount;
  }

  function getNextTier(qty) {
    for (const tier of DISCOUNT_TIERS) {
      if (qty < tier.min) return tier;
    }
    return null;
  }

  function getCurrentTier(qty) {
    let cur = DISCOUNT_TIERS[0];
    for (const tier of DISCOUNT_TIERS) {
      if (qty >= tier.min) cur = tier;
    }
    return cur;
  }

  function getTotalQuantity() {
    return designs.reduce(
      (sum, d) => sum + (d.sizeBlock ? d.sizeBlock.qty : 0),
      0
    );
  }

  const DEFAULT_DESIGN_QTY = 10;

  /** Keep qty in sync across popular/custom tabs so mode switches don't reset it. */
  function syncDesignQty(design, q) {
    const qty = Math.max(1, parseInt(q, 10) || DEFAULT_DESIGN_QTY);
    design.customData.qty = qty;
    design.popularData.qty = qty;
    const mode = design.activeTab;
    const base = mode === "custom" ? design.customData : design.popularData;
    design.sizeBlock = { type: mode, ...base };
    return qty;
  }

  function getTotalPrice() {
    return designs.reduce(
      (sum, d) => sum + (d.sizeBlock ? d.sizeBlock.total : 0),
      0
    );
  }

  function getTotalOriginalPrice() {
    return designs.reduce(
      (sum, d) => sum + (d.sizeBlock ? d.sizeBlock.originalTotal : 0),
      0
    );
  }

  function convertToInches(pixels, dpi) {
    return pixels / dpi / 4.167;
  }

  function getImageDPI(file) {
    return new Promise((resolve) => {
      try {
        EXIF.getData(file, function () {
          const xRes = EXIF.getTag(this, "XResolution");
          const resUnit = EXIF.getTag(this, "ResolutionUnit");
          if (xRes && resUnit === 2) resolve(xRes);
          else resolve(72);
        });
      } catch (e) {
        resolve(72);
      }
    });
  }

  function fileToDataURL(file) {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = (e) => resolve(e.target.result);
      r.onerror = reject;
      r.readAsDataURL(file);
    });
  }

  // ============================================================
  // ADAPT DIMENSIONS FROM PIXELS / DPI to clamped inches
  // ============================================================
  async function computeSuggestedSize(file) {
    const dataURL = await fileToDataURL(file);
    const tempImg = new Image();
    await new Promise((resolve, reject) => {
      tempImg.onload = resolve;
      tempImg.onerror = reject;
      tempImg.src = dataURL;
    });

    const pixelW = tempImg.naturalWidth;
    const pixelH = tempImg.naturalHeight;
    const MAX_PIXELS = 30000;
    if (pixelW > MAX_PIXELS || pixelH > MAX_PIXELS) {
      throw new Error(
        `Image dimensions are too large (${pixelW}x${pixelH}). Please upload a smaller image.`
      );
    }

    const dpi = await getImageDPI(file);
    let widthIn = convertToInches(pixelW, dpi);
    let heightIn = convertToInches(pixelH, dpi);

    const MIN_W = 1,
      MAX_W = 28;
    const MIN_H = 1,
      MAX_H = 100;

    if (widthIn < MIN_W || heightIn < MIN_H) {
      const f = Math.max(MIN_W / widthIn, MIN_H / heightIn);
      widthIn *= f;
      heightIn *= f;
    }
    if (widthIn > MAX_W || heightIn > MAX_H) {
      const f = Math.min(MAX_W / widthIn, MAX_H / heightIn);
      widthIn *= f;
      heightIn *= f;
    }

    return {
      dataURL,
      pixelW,
      pixelH,
      dpi: Math.round(dpi),
      widthIn: parseFloat(widthIn.toFixed(2)),
      heightIn: parseFloat(heightIn.toFixed(2)),
    };
  }

  // ============================================================
  // DESIGN LIFECYCLE
  // ============================================================
  async function createDesign(file) {
    const errorMessage = document.getElementById("upload-file-error");
    errorMessage.classList.remove("active");

    let info;
    try {
      info = await computeSuggestedSize(file);
    } catch (err) {
      const msg = err.message || "Failed to process image.";
      // If we're still on the upload screen, use the inline error;
      // otherwise fall back to alert (the upload box is hidden).
      const initialUploadVisible =
        document.getElementById("upload-artbox").offsetParent !== null;
      if (initialUploadVisible) {
        errorMessage.classList.add("active");
        errorMessage.textContent = msg;
      } else {
        alert(msg);
      }
      return null;
    }

    const id = nextDesignId++;
    // Default popular pick = the popular tile closest to the image's
    // best-fit dimensions (so first-time view already has a sensibly
    // highlighted tile, not an arbitrary 4x4).
    const defaultPopular = findClosestPopular(info.widthIn, info.heightIn);
    const design = {
      id,
      file,
      imageURL: info.dataURL,
      pixelWidth: info.pixelW,
      pixelHeight: info.pixelH,
      dpi: info.dpi,
      suggestedWidth: info.widthIn,
      suggestedHeight: info.heightIn,
      fabric: "Light Fabric",
      // New designs open on the Popular Sizes tab so users get a
      // 1-tap selection instead of facing empty W/H inputs.
      activeTab: "popular",
      customData: {
        width: info.widthIn,
        height: info.heightIn,
        qty: DEFAULT_DESIGN_QTY,
      },
      popularData: {
        width: defaultPopular.w,
        height: defaultPopular.h,
        qty: DEFAULT_DESIGN_QTY,
      },
      sizeBlock: null,
      element: null,
    };
    design.sizeBlock = { type: "popular", ...design.popularData };

    designs.push(design);
    renderDesignCard(design);
    showVariations();

    // This design is now the latest — it drives the mockup from here on.
    lastActiveDesign = design;
    // Always mount (or refresh) the mockup so its imageURL is pushed to
    // the blob <img> tags immediately.
    mountClothMockups(design);
    if (designs.length > 1) {
      // Auto-fold all previous designs so the user focuses on the newest.
      collapseOtherDesigns(design);
    }

    recalculateAll();
    return design;
  }

  function removeDesign(designId) {
    const idx = designs.findIndex((d) => d.id === designId);
    if (idx === -1) return;
    const design = designs[idx];
    if (design.element) design.element.remove();
    designs.splice(idx, 1);

    if (designs.length === 0) {
      lastActiveDesign = null;
      resetToInitial();
    } else {
      designs.forEach((d, i) => {
        const numEl = d.element.querySelector(".design-number");
        if (numEl) numEl.textContent = i + 1;
      });
      // If the removed design was the one shown in the mockup, fall back
      // to the last remaining design so the mockup stays meaningful.
      if (lastActiveDesign === design || !designs.includes(lastActiveDesign)) {
        lastActiveDesign = designs[designs.length - 1];
        mountClothMockups(lastActiveDesign);
      }
      recalculateAll();
    }
  }

  function showVariations() {
    document.getElementById("artwork-box").style.display = "none";
    document.getElementById("short-description").style.display = "none";
    document.getElementById("happy-creators").style.display = "none";
    document.getElementById("vulgrCreatorContainer").style.display = "none";
    document
      .querySelector(".product .product__media")
      ?.classList.add("hidden");
    document.getElementById("dtf-variations").classList.remove("hidden");
  }

  function resetToInitial() {
    document.getElementById("artwork-box").style.display = "";
    document.getElementById("short-description").style.display = "";
    document.getElementById("happy-creators").style.display = "";
    document.getElementById("vulgrCreatorContainer").style.display = "";
        document
      .querySelector(".product .product__media")
      ?.classList.remove("hidden");
    document.getElementById("dtf-variations").classList.add("hidden");

    const dtfThumbnail = document.getElementById("dtf-thumbnail");
    if (dtfThumbnail) dtfThumbnail.classList.add("hidden");

    document.querySelector("#pcs-final-price").textContent = "00.00";
    document.querySelector("#pcs-cutoff-price").textContent = "00.00";
    updateShippingBar(0);
    updateBuyBarSummary(0);
    nextDesignId = 1;
  }

  // ============================================================
  // CLOTH MOCKUPS in product media area (always shows the first design)
  // ============================================================

  // Compute the actual printed size of a design given a selected sheet.
  // The image is fitted into the sheet while maintaining its native AR.
  // Returns { w, h, fillPct } where fillPct is how much of the sheet area
  // the design uses (useful for showing "50% of 4×2 sheet").
  function getFittedDesignSize(design, sheetW, sheetH) {
    if (!design || !design.pixelWidth || !design.pixelHeight || !sheetW || !sheetH) {
      return { w: sheetW || 2, h: sheetH || 2, fillPct: 100 };
    }
    const imgR = design.pixelWidth / design.pixelHeight;
    let fitW = sheetW;
    let fitH = fitW / imgR;
    if (fitH > sheetH) {
      fitH = sheetH;
      fitW = fitH * imgR;
    }
    const fillPct = Math.round((fitW * fitH) / (sheetW * sheetH) * 100);
    return {
      w: parseFloat(fitW.toFixed(2)),
      h: parseFloat(fitH.toFixed(2)),
      fillPct,
    };
  }

  function mountClothMockups(design) {
    if (!design) return;
  const productMedia = document.querySelector(".product .product__media");
    if (!productMedia) return;

    let dtfThumbnail = document.getElementById("dtf-thumbnail");
    if (!dtfThumbnail) {
      productMedia.insertAdjacentHTML("beforeend", dtfThumbnailHTML);
      dtfThumbnail = document.getElementById("dtf-thumbnail");

      // Wire garment tab switching.
      document.querySelectorAll(".garment-tab").forEach((btn) => {
        btn.addEventListener("click", () => {
          document.querySelectorAll(".garment-tab").forEach((b) => b.classList.remove("active"));
          document.querySelectorAll(".mockup-panel").forEach((p) => p.classList.remove("active"));
          btn.classList.add("active");
          const panel = document.getElementById(`mockup-panel-${btn.dataset.garment}`);
          if (panel) panel.classList.add("active");
        });
      });

      colorInject();
        } else {
      dtfThumbnail.classList.remove("hidden");
    }

    // Set all blob images to the first design's uploaded image.
    document.querySelectorAll(".mockup-blob-img").forEach((img) => (img.src = design.imageURL));
    updateClothMockups(design);
    applyMockupColorForFabric(design.fabric);
  }

  function updateClothMockups(design) {
    if (!design) return;
    const block = design.sizeBlock;
    if (!block) return;

    // Swap blob images to the active design's uploaded image.
    if (design.imageURL) {
      document.querySelectorAll(".mockup-blob-img").forEach((img) => (img.src = design.imageURL));
    }

    const sheetW = block.width || 2;
    const sheetH = block.height || 2;
    const sheetArea = sheetW * sheetH;
    const fitted = getFittedDesignSize(design, sheetW, sheetH);

    // Determine global position label (same for all garments).
    // Use the FIRST garment's centerArea as the reference threshold.
    const firstCfg = Object.values(GARMENT_CONFIGS)[0];
    const isCenter = sheetArea >= firstCfg.centerArea;

    // Update each garment overlay.
    Object.entries(GARMENT_CONFIGS).forEach(([key, cfg]) => {
      const overlay = document.getElementById(`mockup-overlay-${key}`);
      if (!overlay) return;

      const garmentCenter = sheetArea >= cfg.centerArea;
      const pos = garmentCenter ? cfg.center : (cfg.leftChest || cfg.center);

      // Design width as % of the garment-image container width.
      const displayW = Math.min(
        (fitted.w / cfg.maxPrintW) * cfg.printWidthPct,
        cfg.printWidthPct
      );

      // Position: left edge = center.cx - half width; top = center.cy (transform: translateY(-50%) in CSS).
      overlay.style.width = `${displayW}%`;
      overlay.style.left = `${pos.cx - displayW / 2}%`;
      overlay.style.top = `${pos.cy}%`;

      // Update ruler labels.
      const bottomSpan = overlay.querySelector(".mdim-bottom span");
      const leftSpan = overlay.querySelector(".mdim-left span");
      if (bottomSpan) bottomSpan.textContent = `${fitted.w.toFixed(2)}"`;
      if (leftSpan) leftSpan.textContent = `${fitted.h.toFixed(2)}"`;
    });

    // Update info bar.
    const posEl = document.getElementById("mockup-position-label");
    const sizeEl = document.getElementById("mockup-size-label");
    const fillEl = document.getElementById("mockup-fill-label");

    if (posEl) posEl.textContent = isCenter ? "Center Print" : "Left Chest";
    if (sizeEl) sizeEl.textContent = `${fitted.w.toFixed(2)}" × ${fitted.h.toFixed(2)}"`;
    if (fillEl) {
      fillEl.textContent = fitted.fillPct < 95
        ? `(${fitted.fillPct}% of ${sheetW}×${sheetH} sheet)`
        : "";
    }
  }

  // ============================================================
  // RENDER DESIGN CARD
  // ============================================================
  function renderDesignCard(design) {
    const card = document.createElement("div");
    card.className = "design-card";
    card.dataset.designId = design.id;

    const safeName = (design.file.name || `design-${design.id}`).replace(
      /[<>]/g,
      ""
    );
    // Header badge reflects PRINT DPI for the currently-selected size
    // (live-updated by recalculateAll). Initial value derived from the
    // freshly-set sizeBlock.
    const initialPrint = getPrintDpiInfo(
      getPrintDpi(
        design,
        design.sizeBlock.width,
        design.sizeBlock.height
      )
    );

    const aspect =
      design.suggestedHeight > 0
        ? design.suggestedWidth / design.suggestedHeight
        : 1;

    const renderTilesHTML = (categories) =>
      categories
        .map(
          (cat) => `
          <div class="size-category" data-cat="${cat.id}">
            <h6 class="size-category-title">
              ${cat.title} <span>${cat.subtitle}</span>
            </h6>
            <div class="size-category-scroll">
              <div class="size-category-grid">
                ${cat.sizes
              .map((s) => {
                const price = findBasePrice(s.w * s.h);
                const print = getPrintDpiInfo(
                  getPrintDpi(design, s.w, s.h)
                );
                return `<button type="button" class="size-tile"
                      data-w="${s.w}" data-h="${s.h}"
                      title="${print.dpi} DPI · ${print.label}">
                      <span class="size-tile-dim">${s.w}"&times;${s.h}"</span>
                      <span class="size-tile-price">$${price.toFixed(2)}</span>
                    </button>`;
              })
              .join("")}
              </div>
              <span class="scroll-hint" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>
              </span>
            </div>
          </div>`
        )
        .join("");

    const tailoredCategoriesHTML = renderTilesHTML(buildTailoredSizes(aspect));
    const popularCategoriesHTML = renderTilesHTML(POPULAR_SIZES_CATEGORIES);

    card.innerHTML = `
      <div class="design-card-header">
        <div class="design-number"></div>
        <img class="design-thumbnail" src="${design.imageURL}" alt="thumbnail" />
        <div class="design-info">
          <p class="design-name"></p>
          <span class="dpi-badge expand-only ${initialPrint.cls}">${initialPrint.icon} ${initialPrint.dpi} DPI · ${initialPrint.label}</span>
          <span class="size-summary collapse-only"></span>
        </div>
        <div class="compact-qty-stepper collapse-only">
          <button type="button" class="cqs-down" aria-label="Decrease quantity">−</button>
          <input type="number" class="cqs-num" min="1" step="1" inputmode="numeric" aria-label="Quantity" />
          <button type="button" class="cqs-up" aria-label="Increase quantity">+</button>
        </div>
        <p class="compact-total collapse-only">$0.00</p>
        <button type="button" class="edit-btn collapse-only">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 20h9"></path>
            <path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
          </svg>
          <span>Edit size &amp; qty</span>
        </button>
        <div class="design-card-actions">
          <button type="button" class="design-toggle-btn" title="Collapse / expand">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>
          <button type="button" class="design-remove-btn" title="Remove design">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 6h18" />
              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
              <line x1="10" x2="10" y1="11" y2="17" />
              <line x1="14" x2="14" y1="11" y2="17" />
            </svg>
          </button>
        </div>
      </div>

      <div class="design-card-body expand-only">
      <div class="best-fit-card" title="Click to apply best fit size">
        <span class="bf-star">⭐</span>
        <div class="bf-info">
          <p class="bf-label">Best Fit For Your Design</p>
          <p class="bf-same-price">SAME PRICE</p>
          <h4 class="bf-size">${design.suggestedWidth.toFixed(
      2
    )}" × ${design.suggestedHeight.toFixed(2)}"</h4>
        </div>
        <p class="bf-price">$0.00</p>
      </div>

      <div class="fabric-selector-compact">
        <p class="fabric-label">Fabric: <strong class="fabric-color-code">#737373</strong></p>
        <div class="fabric-options-compact">
          <button type="button" class="fabric-option active" data-fabric="Light Fabric">
            <img src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/light-fabric.png" alt="Light" />
            <span>Light Fabric</span>
          </button>
          <button type="button" class="fabric-option" data-fabric="Dark Fabric">
            <img src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/dark-fabric.png" alt="Dark" />
            <span>Dark Fabric</span>
          </button>
        </div>
      </div>

      <div class="size-section design-size-section">
        <div class="size-section-header">
          <p class="size-section-title">SELECT SIZE</p>
          <button type="button" class="size-mode-toggle">
            <svg class="ssm-icon-popular" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
            <svg class="ssm-icon-custom" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline></svg>
            <span class="ssm-label">Popular Sizes</span>
          </button>
        </div>

        <div class="size-mode size-mode-custom active">
          <div class="custom-dim-inputs">
            <input type="number" class="cw input-field" min="0.5" max="28" step="0.01" placeholder="W" />
            <span class="x-sep">&times;</span>
            <input type="number" class="ch input-field" min="0.5" max="100" step="0.01" placeholder="H" />
            <span class="unit-label">inches</span>
          </div>
          <div class="custom-tip">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line></svg>
            <span>Enter your exact dimensions for a perfect fit</span>
          </div>
          <div class="tailored-banner">
            <svg class="tb-star" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
            <div class="tb-info">
              <strong>Sizes tailored to your design</strong>
              <p>Matched to your image's aspect ratio (<span class="aspect-display">${aspect.toFixed(
      1
    )}:1</span>)</p>
            </div>
          </div>
          <div class="tailored-categories">${tailoredCategoriesHTML}</div>
        </div>

        <div class="size-mode size-mode-popular">
          <div class="popular-categories">${popularCategoriesHTML}</div>
        </div>

        <div class="size-summary-row">
          <div class="ssr-info">
            <span class="ssr-label">Selected</span>
            <span class="ssr-size-value">—</span>
          </div>
          <div class="ssr-qty">
            <button type="button" class="ssr-down" aria-label="Decrease quantity">−</button>
            <input type="number" class="ssr-qty-input input-field" min="1" />
            <button type="button" class="ssr-up" aria-label="Increase quantity">+</button>
          </div>
          <div class="ssr-totals">
            <span class="ssr-total">$0.00</span>
            <div class="ssr-meta">
              <span class="ssr-original"></span>
              <span class="ssr-discount-pill"></span>
            </div>
          </div>
        </div>
      </div>

      <div class="design-discount-suggestion">
        <span class="ds-star">⭐</span>
        <p class="ds-text"></p>
        <button type="button" class="ds-apply">APPLY</button>
      </div>

      ${VOLUME_DISCOUNT_PANEL_HTML}
      </div>
    `;

    design.element = card;
    designsContainer.appendChild(card);

    const nameEl = card.querySelector(".design-name");
    nameEl.textContent = safeName;
    nameEl.title = safeName;
    const idx = designs.indexOf(design);
    card.querySelector(".design-number").textContent = idx + 1;

    // Fill custom dim inputs.
    const cw = card.querySelector(".size-mode-custom .cw");
    const ch = card.querySelector(".size-mode-custom .ch");
    cw.value = design.customData.width.toFixed(2);
    ch.value = design.customData.height.toFixed(2);

    // Fill summary qty.
    const ssrQ = card.querySelector(".ssr-qty-input");
    ssrQ.value = design.sizeBlock.qty;

    // Highlight initial active tile (if any).
    refreshActiveSizeTile(card, design);

    setupDesignCardListeners(design);
    updateVolumeDiscountPanel(design);
    updateDesignSuggestion(design);
  }

  // ============================================================
  // EVENT LISTENERS PER DESIGN CARD
  // ============================================================
  function setupDesignCardListeners(design) {
    const card = design.element;

    card
      .querySelector(".design-remove-btn")
      .addEventListener("click", () => removeDesign(design.id));

    const fabricCodeEl = card.querySelector(".fabric-color-code");
    const updateFabricCode = () => {
      fabricCodeEl.textContent =
        design.fabric === "Light Fabric" ? "#F5F5F5" : "#1A1A1A";
    };
    updateFabricCode();

    // Hide the right-edge scroll cue (fade + chevron) when there's
    // nothing left to scroll, or when the row doesn't overflow at all.
    // We collect every wrapper's update fn on the card so we can re-run
    // them after expand/collapse (a hidden card measures as 0-width and
    // would otherwise stay flagged as "no overflow" forever).
    const scrollHintUpdaters = [];
    card.querySelectorAll(".size-category-scroll").forEach((wrap) => {
      const grid = wrap.querySelector(".size-category-grid");
      if (!grid) return;
      const update = () => {
        // If the grid is currently hidden (e.g., card collapsed, or
        // the OTHER size mode), skip — we'll be called again when it
        // becomes visible. Don't pre-emptively hide the chevron.
        if (grid.clientWidth === 0) return;
        const overflows = grid.scrollWidth - grid.clientWidth > 1;
        const atEnd =
          grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
        wrap.classList.toggle("scrolled-end", !overflows || atEnd);
      };
      grid.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      scrollHintUpdaters.push(update);
      // Initial state once the layout has settled.
      requestAnimationFrame(update);
    });
    card._refreshScrollHints = () => {
      // Two RAFs so the browser has time to paint after `.collapsed`
      // is toggled before we measure.
      requestAnimationFrame(() =>
        requestAnimationFrame(() =>
          scrollHintUpdaters.forEach((fn) => fn())
        )
      );
    };

    card.querySelectorAll(".fabric-option").forEach((btn) => {
      btn.addEventListener("click", () => {
        card
          .querySelectorAll(".fabric-option")
          .forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        design.fabric = btn.dataset.fabric;
        applyMockupColorForFabric(design.fabric);
        updateFabricCode();
      });
    });

    // === SIZE SECTION ===
    const customMode = card.querySelector(".size-mode-custom");
    const popularMode = card.querySelector(".size-mode-popular");
    const modeToggleBtn = card.querySelector(".size-mode-toggle");
    const cw = card.querySelector(".size-mode-custom .cw");
    const ch = card.querySelector(".size-mode-custom .ch");
    const ssrQ = card.querySelector(".ssr-qty-input");
    const ssrDown = card.querySelector(".ssr-down");
    const ssrUp = card.querySelector(".ssr-up");

    const setActiveMode = (mode, opts) => {
      const recalc = !opts || opts.recalc !== false;
      if (design.sizeBlock) {
        const qty = design.sizeBlock.qty;
        design.customData.qty = qty;
        design.popularData.qty = qty;
      }
      design.activeTab = mode;
      customMode.classList.toggle("active", mode === "custom");
      popularMode.classList.toggle("active", mode === "popular");
      card.classList.toggle("popular-mode", mode === "popular");
      const label = modeToggleBtn.querySelector(".ssm-label");
      if (label) {
        label.textContent = mode === "custom" ? "Popular Sizes" : "Custom Size";
      }
      const data = mode === "custom" ? design.customData : design.popularData;
      design.sizeBlock = { type: mode, ...data };
      ssrQ.value = data.qty;
      const cqsIn = card.querySelector(".cqs-num");
      if (cqsIn && document.activeElement !== cqsIn) cqsIn.value = data.qty;
      refreshActiveSizeTile(card, design);
      // The newly-visible mode's size grids were display:none until now,
      // so re-run the scroll-cue measurement to expose the chevron.
      if (typeof card._refreshScrollHints === "function") {
        card._refreshScrollHints();
      }
      if (recalc) recalculateAll();
    };
    // Initialize mode label / state without forcing an extra recalc.
    setActiveMode(design.activeTab || "custom", { recalc: false });

    modeToggleBtn.addEventListener("click", () => {
      setActiveMode(design.activeTab === "custom" ? "popular" : "custom");
    });

    const commitCustom = () => {
      let w = parseFloat(cw.value);
      let h = parseFloat(ch.value);
      if (isNaN(w) || w <= 0) w = design.customData.width;
      if (isNaN(h) || h <= 0) h = design.customData.height;
      if (w > MAX_W_IN) w = MAX_W_IN;
      if (h > MAX_H_IN) h = MAX_H_IN;
      design.customData.width = w;
      design.customData.height = h;
      if (design.activeTab === "custom") {
        design.sizeBlock = { type: "custom", ...design.customData };
      }
      refreshActiveSizeTile(card, design);
      recalculateAll();
    };

    cw.addEventListener("input", () => {
      let w = parseFloat(cw.value);
      if (isNaN(w) || w <= 0) return;
      if (w > MAX_W_IN) {
        w = MAX_W_IN;
        cw.value = String(MAX_W_IN);
      }
      design.customData.width = w;
      if (design.activeTab === "custom") {
        design.sizeBlock = { type: "custom", ...design.customData };
      }
      refreshActiveSizeTile(card, design);
      recalculateAll();
    });
    cw.addEventListener("blur", () => {
      cw.value = design.customData.width.toFixed(2);
    });

    ch.addEventListener("input", () => {
      let h = parseFloat(ch.value);
      if (isNaN(h) || h <= 0) return;
      if (h > MAX_H_IN) {
        h = MAX_H_IN;
        ch.value = String(MAX_H_IN);
      }
      design.customData.height = h;
      if (design.activeTab === "custom") {
        design.sizeBlock = { type: "custom", ...design.customData };
      }
      refreshActiveSizeTile(card, design);
      recalculateAll();
    });
    ch.addEventListener("blur", () => {
      ch.value = design.customData.height.toFixed(2);
    });

    // Size tiles (custom-mode tailored + popular-mode fixed).
    card.querySelectorAll(".size-tile").forEach((tile) => {
      tile.addEventListener("click", () => {
        const w = parseFloat(tile.dataset.w);
        const h = parseFloat(tile.dataset.h);
        if (!isFinite(w) || !isFinite(h)) return;
        const inCustom = !!tile.closest(".size-mode-custom");
        const mode = inCustom ? "custom" : "popular";
        if (design.activeTab !== mode) {
          setActiveMode(mode, { recalc: false });
        }
        if (mode === "custom") {
          design.customData.width = w;
          design.customData.height = h;
          cw.value = w.toFixed(2);
          ch.value = h.toFixed(2);
      } else {
          design.popularData.width = w;
          design.popularData.height = h;
        }
        design.sizeBlock = {
          type: mode,
          ...(mode === "custom" ? design.customData : design.popularData),
        };
        refreshActiveSizeTile(card, design);
        recalculateAll();
      });
    });

    // Summary row qty input + stepper (single qty control for the design).
    ssrQ.addEventListener("input", () => {
      let q = parseInt(ssrQ.value, 10);
      if (isNaN(q) || q < 1) q = 1;
      syncDesignQty(design, q);
      recalculateAll();
    });
    const stepSummaryQty = (delta) => {
      const current =
        design.sizeBlock?.qty ??
        design.popularData.qty ??
        design.customData.qty ??
        DEFAULT_DESIGN_QTY;
      const newQty = syncDesignQty(design, current + delta);
      ssrQ.value = newQty;
      const cqsN = card.querySelector(".cqs-num");
      if (cqsN) cqsN.value = newQty;
      recalculateAll();
    };
    ssrDown.addEventListener("click", () => stepSummaryQty(-1));
    ssrUp.addEventListener("click", () => stepSummaryQty(+1));

    const cqsNumInput = card.querySelector(".cqs-num");
    if (cqsNumInput) {
      cqsNumInput.value = design.sizeBlock.qty;
      cqsNumInput.addEventListener("click", (e) => e.stopPropagation());
      cqsNumInput.addEventListener("focus", (e) => e.stopPropagation());
      cqsNumInput.addEventListener("input", () => {
        let q = parseInt(cqsNumInput.value, 10);
        if (isNaN(q) || q < 1) q = 1;
        syncDesignQty(design, q);
        if (document.activeElement !== ssrQ) ssrQ.value = q;
        recalculateAll();
      });
      cqsNumInput.addEventListener("blur", () => {
        let q = parseInt(cqsNumInput.value, 10);
        if (isNaN(q) || q < 1) q = 1;
        syncDesignQty(design, q);
        cqsNumInput.value = q;
        ssrQ.value = q;
        recalculateAll();
      });
    }

    // Volume-discount per-design suggestion APPLY.
    card
      .querySelector(".ds-apply")
      .addEventListener("click", () => applyDiscountSuggestion(design));

    // Best-fit card click → switch to custom mode + apply the live
    // proportion-based fit (cached on design._bestFit by the latest
    // refreshBestFitVisibility() call).
    card.querySelector(".best-fit-card").addEventListener("click", () => {
      const fit = design._bestFit;
      if (!fit) return;
      if (design.activeTab !== "custom") {
        setActiveMode("custom", { recalc: false });
      }
      design.customData.width = fit.w;
      design.customData.height = fit.h;
      cw.value = fit.w.toFixed(2);
      ch.value = fit.h.toFixed(2);
      commitCustom();
    });

    // Compact qty stepper (collapsed view) — same qty as summary row.
    const cqsDown = card.querySelector(".cqs-down");
    const cqsUp = card.querySelector(".cqs-up");
    cqsDown.addEventListener("click", (e) => {
      e.stopPropagation();
      stepSummaryQty(-1);
    });
    cqsUp.addEventListener("click", (e) => {
      e.stopPropagation();
      stepSummaryQty(+1);
    });

    // Edit button → expand this card
    card.querySelector(".edit-btn").addEventListener("click", (e) => {
      e.stopPropagation();
      setDesignCollapsed(design, false);
    });

    // Toggle (chevron) button → flip collapsed state. Always available.
    card.querySelector(".design-toggle-btn").addEventListener("click", (e) => {
      e.stopPropagation();
      setDesignCollapsed(design, !card.classList.contains("collapsed"));
    });

    // Tap on collapsed summary → expand
    card
      .querySelector(".design-card-header")
      .addEventListener("click", (e) => {
        if (!card.classList.contains("collapsed")) return;
        // Don't expand on stepper / remove / edit / toggle (those are handled).
        const interactive = e.target.closest(
          ".compact-qty-stepper, .cqs-num, .design-remove-btn, .design-toggle-btn, .edit-btn"
        );
        if (interactive) return;
        setDesignCollapsed(design, false);
      });

    setupDesignVolumeDiscount(card, design);
  }

  function getActiveDesign() {
    // Return the last design the user explicitly touched (uploaded or expanded).
    // Falls back to designs[0] only if lastActiveDesign is stale/removed.
    if (lastActiveDesign && designs.includes(lastActiveDesign)) return lastActiveDesign;
    return designs[0];
  }

  function setDesignCollapsed(design, collapsed) {
    if (!design || !design.element) return;
    design.element.classList.toggle("collapsed", collapsed);
    // After expanding, the previously-hidden size grids are visible
    // for the first time and need to re-measure to show / hide the
    // scroll chevron correctly.
    if (!collapsed && typeof design.element._refreshScrollHints === "function") {
      design.element._refreshScrollHints();
    }
    // When the user manually expands a card, that design becomes the
    // latest active one and drives the mockup. Collapsing never changes it.
    if (!collapsed) {
      lastActiveDesign = design;
      if (document.getElementById("dtf-thumbnail")) {
        applyMockupColorForFabric(design.fabric);
        updateClothMockups(design);
      }
    }
  }

  function collapseOtherDesigns(exceptDesign) {
    designs.forEach((d) => {
      if (d !== exceptDesign) setDesignCollapsed(d, true);
    });
  }

  // ============================================================
  // SIZE TILE / DPI HELPERS
  // ============================================================
  function refreshActiveSizeTile(card, design) {
    const block = design.sizeBlock;
    card.querySelectorAll(".size-tile").forEach((t) =>
      t.classList.remove("active")
    );
    if (!block) return;

    const targetSection = card.querySelector(
      design.activeTab === "custom" ? ".size-mode-custom" : ".size-mode-popular"
    );
    if (!targetSection) return;

    const TOL = 0.05;
    targetSection.querySelectorAll(".size-tile").forEach((tile) => {
      const tw = parseFloat(tile.dataset.w);
      const th = parseFloat(tile.dataset.h);
      if (
        Math.abs(tw - block.width) < TOL &&
        Math.abs(th - block.height) < TOL
      ) {
        tile.classList.add("active");
      }
    });
  }

  // Compute the proportion-based best-fit for the user's CURRENT
  // selection and reflect it in the "Best Fit For Your Design" card.
  // We hide the card whenever the current pick is already a clean
  // proportional fit (i.e. computeBestFitForSize returns null).
  // The computed fit is cached on `design._bestFit` so the click
  // handler can apply it without re-doing the maths.
  function refreshBestFitVisibility(card, design) {
    const bfCard = card.querySelector(".best-fit-card");
    if (!bfCard) return;
    const block = design.sizeBlock;
    if (!block) {
      bfCard.classList.remove("visible");
      design._bestFit = null;
      return;
    }

    const fit = computeBestFitForSize(design, block.width, block.height);
    if (!fit) {
      bfCard.classList.remove("visible");
      design._bestFit = null;
      return;
    }

    // Update size + price labels inside the card.
    const sizeEl = bfCard.querySelector(".bf-size");
    if (sizeEl) {
      sizeEl.textContent = `${fit.w.toFixed(2)}" × ${fit.h.toFixed(2)}"`;
    }

    const fitPrice = findBasePrice(fit.w * fit.h);
    const priceEl = bfCard.querySelector(".bf-price");
    if (priceEl) priceEl.textContent = `$${fitPrice.toFixed(2)}`;

    // "SAME PRICE" label: only when the suggestion lands in the same
    // base-price tier as the current pick (e.g. 2×2 → 2×1.5 stays at
    // $0.37). Hidden when the price actually differs so we don't lie.
    const currentPrice = findBasePrice(block.width * block.height);
    const samePriceEl = bfCard.querySelector(".bf-same-price");
    if (samePriceEl) {
      if (Math.abs(currentPrice - fitPrice) < 0.01) {
        samePriceEl.textContent = "SAME PRICE";
        samePriceEl.style.display = "";
      } else if (fitPrice < currentPrice) {
        const saving = currentPrice - fitPrice;
        samePriceEl.textContent = `SAVE $${saving.toFixed(2)}`;
        samePriceEl.style.display = "";
              } else {
        samePriceEl.style.display = "none";
      }
    }

    design._bestFit = fit;
    bfCard.classList.add("visible");
  }

  // Header DPI badge mirrors print-DPI for the currently-selected size.
  // Replaces the old static file-metadata DPI badge so the user always
  // sees the quality of what they're about to order.
  function refreshDpiBadge(card, design) {
    const badge = card.querySelector(".dpi-badge");
    if (!badge || !design.sizeBlock) return;
    const print = getPrintDpiInfo(
      getPrintDpi(design, design.sizeBlock.width, design.sizeBlock.height)
    );
    badge.classList.remove("low", "medium", "high");
    badge.classList.add(print.cls);
    badge.textContent = `${print.icon} ${print.dpi} DPI · ${print.label}`;
  }

  // ============================================================
  // PRICE RECALCULATION (per-design qty for volume discount)
  // ============================================================
  function recalculateAll() {
    designs.forEach((design) => {
      if (!design.sizeBlock) return;
      const block = design.sizeBlock;
      const designQty = block.qty;
      const discount = calculateDiscountByQty(designQty);
      const discountPct = Math.round(discount * 100);
      const area = block.width * block.height;
      const basePrice = findBasePrice(area);
      const unitPrice = basePrice * (1 - discount);
      const total = unitPrice * block.qty;
      const originalTotal = basePrice * block.qty;

      block.basePrice = basePrice;
      block.unitPrice = unitPrice;
      block.total = total;
      block.originalTotal = originalTotal;

      const card = design.element;

      // Selected size summary row.
      const ssrSize = card.querySelector(".ssr-size-value");
      if (ssrSize) {
        ssrSize.textContent = `${block.width.toFixed(2)}" × ${block.height.toFixed(2)}"`;
      }
      const ssrQ = card.querySelector(".ssr-qty-input");
      if (ssrQ && document.activeElement !== ssrQ) {
        ssrQ.value = block.qty;
      }
      const ssrTotal = card.querySelector(".ssr-total");
      if (ssrTotal) ssrTotal.textContent = `$${total.toFixed(2)}`;
      const ssrOriginal = card.querySelector(".ssr-original");
      const ssrPill = card.querySelector(".ssr-discount-pill");
      if (discount > 0 && originalTotal > total + 0.01) {
        if (ssrOriginal) {
          ssrOriginal.textContent = `$${originalTotal.toFixed(2)}`;
          ssrOriginal.style.display = "";
        }
        if (ssrPill) {
          ssrPill.textContent = `${discountPct}% off`;
          ssrPill.style.display = "";
        }
      } else {
        if (ssrOriginal) {
          ssrOriginal.textContent = "";
          ssrOriginal.style.display = "none";
        }
        if (ssrPill) {
          ssrPill.textContent = "";
          ssrPill.style.display = "none";
        }
      }

      // (Best-fit size + price are populated dynamically by
      // refreshBestFitVisibility based on the user's CURRENT pick.)

      // Collapsed-view summary (size + qty stepper + line total)
      const sizeSummary = card.querySelector(".size-summary");
      if (sizeSummary) {
        sizeSummary.textContent = `${block.width.toFixed(2)}" × ${block.height.toFixed(2)}"`;
      }
      const cqsNum = card.querySelector(".cqs-num");
      if (cqsNum && document.activeElement !== cqsNum) {
        cqsNum.value = block.qty;
      }
      const compactTotal = card.querySelector(".compact-total");
      if (compactTotal) compactTotal.textContent = `$${block.total.toFixed(2)}`;

      // Conditionally show "Best Fit For Your Design" card (only when
      // the user's current size would print at Low-Res quality).
      refreshBestFitVisibility(card, design);

      // Live-update the header DPI badge for the currently-selected size.
      refreshDpiBadge(card, design);

      updateVolumeDiscountPanel(design);
      updateDesignSuggestion(design);
    });

    // Final + cutoff price
    const finalTotal = getTotalPrice();
    const originalTotal = getTotalOriginalPrice();

    const priceElement = document.querySelector("#pcs-final-price");
    const cutoffPriceElement = document.querySelector("#pcs-cutoff-price");
    const cutoffPriceBlock = document.querySelector(
      ".pcs-price__ticker.cutoff-price"
    );

    if (cutoffPriceElement && cutoffPriceBlock) {
      if (originalTotal > finalTotal + 0.001) {
        cutoffPriceBlock.style.display = "inline";
        animatePriceChange(
          cutoffPriceElement,
          parseFloat(cutoffPriceElement.textContent) || 0,
          originalTotal
        );
      } else {
        cutoffPriceBlock.style.display = "none";
      }
    }
    if (priceElement) {
      animatePriceChange(
        priceElement,
        parseFloat(priceElement.textContent) || 0,
        finalTotal
      );
    }

    updateShippingBar(finalTotal);
    updateBuyBarSummary(finalTotal);

    // Calculator (PCS) hidden field – kept for backward compat
              const calculator = document.querySelector("#calculator");
              if (calculator) {
      const priceInput = calculator.querySelector(
        "input[name='properties[Price]']"
      );
      if (priceInput) priceInput.value = finalTotal.toFixed(2);
    }

    // Keep the garment mockup in sync with the currently expanded design.
    if (designs.length > 0 && document.getElementById("dtf-thumbnail")) {
      updateClothMockups(getActiveDesign());
    }

    safePriceUpdation();
  }

  function safePriceUpdation() {
    if (typeof window.PriceUpdation === "function") {
      try {
        window.PriceUpdation();
      } catch (e) { }
    }
  }

  // ============================================================
  // VOLUME DISCOUNT PANEL & PER-DESIGN SUGGESTION
  // ============================================================
  function updateVolumeDiscountPanel(design) {
    const card = design?.element;
    if (!card) return;
    const panel = card.querySelector(".volume-discount-panel");
    if (!panel) return;

    const qty = design.sizeBlock ? design.sizeBlock.qty : 0;
    const tiers = panel.querySelectorAll(".vd-tier");
    const currentDiscount = calculateDiscountByQty(qty);

    tiers.forEach((t) => {
      const tierPct =
        parseInt(t.querySelector("strong").textContent, 10) / 100;
      t.classList.toggle(
        "active",
        Math.abs(tierPct - currentDiscount) < 0.0001
      );
    });

    const badge = panel.querySelector(".vd-discount-badge");
    if (badge) {
      if (currentDiscount > 0) {
        badge.textContent = Math.round(currentDiscount * 100) + "% OFF";
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    const fill = panel.querySelector(".vd-progress-fill");
    if (fill) {
      const pct = Math.min((qty / 250) * 100, 100);
      fill.style.width = pct + "%";
    }

    const msg = panel.querySelector(".vd-progress-message");
    if (!msg) return;
    if (qty <= 0) {
      msg.textContent = "Increase quantity to see your savings unlock here.";
      return;
    }
    const nextTier = getNextTier(qty);
    if (nextTier) {
      const more = nextTier.min - qty;
      const nextPct = Math.round(nextTier.discount * 100);
      const saving = projectedSavings(more, nextTier.discount, design);
      msg.innerHTML = `Add <strong>${more}</strong> more to unlock <strong>${nextPct}% off</strong> and save <strong>$${saving.toFixed(
        2
      )}</strong>`;
    } else {
      msg.innerHTML = `🎉 You've unlocked our maximum <strong>50% off</strong> discount!`;
    }
  }

  function projectedSavings(more, targetDiscount, design) {
    if (!design?.sizeBlock) return 0;
    const currentQty = design.sizeBlock.qty;
    const currentOrig =
      design.sizeBlock.originalTotal ||
      design.sizeBlock.basePrice * currentQty;
    if (currentQty === 0) return 0;
    const avgUnitOrig = currentOrig / currentQty;
    const projectedOrig = avgUnitOrig * (currentQty + more);
    const projectedDiscounted = projectedOrig * (1 - targetDiscount);
    return Math.max(projectedOrig - projectedDiscounted, 0);
  }

  function updateDesignSuggestion(design) {
    const card = design.element;
    if (!card) return;
    const banner = card.querySelector(".design-discount-suggestion");
    const text = card.querySelector(".ds-text");
    const qty = design.sizeBlock ? design.sizeBlock.qty : 0;
    const nextTier = getNextTier(qty);
    if (!nextTier) {
      banner.classList.remove("visible");
      return;
    }
    const more = nextTier.min - qty;
    if (more <= 0) {
      banner.classList.remove("visible");
      return;
    }
    const nextPct = Math.round(nextTier.discount * 100);
    text.innerHTML = `Add <strong>${more}</strong> more for <strong>${nextPct}%</strong> off`;
    banner.classList.add("visible");
  }

  function applyDiscountSuggestion(design) {
    const qty = design.sizeBlock ? design.sizeBlock.qty : 0;
    const nextTier = getNextTier(qty);
    if (!nextTier) return;
    const more = nextTier.min - qty;
    if (more <= 0) return;

    const card = design.element;
    const current =
      design.sizeBlock?.qty ??
      design.popularData.qty ??
      design.customData.qty ??
      DEFAULT_DESIGN_QTY;
    const newQty = syncDesignQty(design, current + more);
    const ssrQ = card.querySelector(".ssr-qty-input");
    if (ssrQ) ssrQ.value = newQty;
    const cqs = card.querySelector(".cqs-num");
    if (cqs) cqs.value = newQty;
    recalculateAll();
  }

  function setQtyForDesign(design, qty) {
    if (!design?.sizeBlock) return;
    const card = design.element;
    const newQty = syncDesignQty(design, qty);
    const ssrQ = card.querySelector(".ssr-qty-input");
    if (ssrQ) ssrQ.value = newQty;
    const cqs = card.querySelector(".cqs-num");
    if (cqs) cqs.value = newQty;
    recalculateAll();
  }

  function setupDesignVolumeDiscount(card, design) {
    const panel = card.querySelector(".volume-discount-panel");
    if (!panel) return;
    panel.querySelectorAll(".vd-tier").forEach((tier) => {
      tier.addEventListener("click", () => {
        const tierMin = parseInt(tier.dataset.min, 10);
        if (isNaN(tierMin)) return;
        setQtyForDesign(design, tierMin);
      });
    });
  }

  // ============================================================
  // INITIAL UPLOAD HANDLER (first upload from artwork-box)
  // ============================================================
  function setupInitialUpload() {
    const fileInput = document.getElementById("upload-file");
    const chooseFileBtn = document.getElementById("dtf-choose-file-btn");

    chooseFileBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      fileInput.value = "";
      fileInput.click();
    });

    fileInput.addEventListener("change", async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      await createDesign(file);
      fileInput.value = "";
    });
  }

  // ============================================================
  // ADD ANOTHER DESIGN HANDLER
  // ============================================================
  function setupAddAnotherDesign() {
    if (!addAnotherDesignInput) return;
    addAnotherDesignInput.addEventListener("change", async (e) => {
      const file = e.target.files[0];
      if (!file) return;
      await createDesign(file);
      addAnotherDesignInput.value = "";
    });
  }

  // ============================================================
  // BUY BAR LABEL (total sheets + per-unit price) & SHIPPING
  // ============================================================
  function updateBuyBarSummary(orderTotal) {
    const totalQty = getTotalQuantity();
    const labelEl = document.getElementById("dtf-pcs-total-label");
    const unitEl = document.getElementById("dtf-pcs-unit-price");
    if (labelEl) {
      const word = totalQty === 1 ? "SHEET" : "SHEETS";
      labelEl.textContent = `TOTAL · ${totalQty} ${word}`;
    }
    if (unitEl) {
      if (totalQty > 0) {
        unitEl.textContent = `$${(orderTotal / totalQty).toFixed(2)}/ea`;
        unitEl.style.display = "";
      } else {
        unitEl.textContent = "";
        unitEl.style.display = "none";
      }
    }
  }

  function updateShippingBar(orderTotal) {
    const shippingWrap = document.getElementById("dtf-pcs-shipping");
    const fillEl = document.getElementById("dtf-pcs-shipping-fill");
    const textEl = document.getElementById("dtf-pcs-shipping-text");
    if (!shippingWrap || !fillEl) return;

    const total = Math.max(0, parseFloat(orderTotal) || 0);
    const toFree = FREE_SHIP_THRESHOLD - total;

    if (toFree <= 0) {
      shippingWrap.classList.add("is-free");
      if (textEl) {
        textEl.innerHTML = "You unlocked <strong>free shipping</strong>";
      }
      fillEl.style.width = "100%";
    } else {
      shippingWrap.classList.remove("is-free");
      if (textEl) {
        textEl.innerHTML = `Add <strong>$${toFree.toFixed(
          2
        )}</strong> more for <strong>free shipping</strong>`;
      }
      const pct = Math.min(
        100,
        Math.round(
          ((FREE_SHIP_THRESHOLD - toFree) / FREE_SHIP_THRESHOLD) * 100
        )
      );
      fillEl.style.width = `${pct}%`;
    }
  }

  function playCartButtonShine() {
    const btn = document.getElementById("dtf-add-to-cart");
    if (!btn || btn.classList.contains("loading")) return;
    btn.classList.remove("shine");
    void btn.offsetWidth;
    btn.classList.add("shine");
    if (btn._shineClearTimer) clearTimeout(btn._shineClearTimer);
    btn._shineClearTimer = setTimeout(() => btn.classList.remove("shine"), 1700);
  }

  function setupCartButtonShine() {
    const btn = document.getElementById("dtf-add-to-cart");
    if (!btn || btn.dataset.shineBound) return;
    btn.dataset.shineBound = "true";
    setTimeout(playCartButtonShine, 1500);
    setInterval(playCartButtonShine, 4000);
  }

  // ============================================================
  // ADD TO CART
  // Each design becomes its own line item (with its own file).
  // ============================================================
  function addToCartEvent() {
    if (!dtf_add_to_cart) return;
    if (dtf_add_to_cart.dataset.bound) return;
    dtf_add_to_cart.dataset.bound = "true";

    dtf_add_to_cart.addEventListener("click", async (e) => {
      e.preventDefault();
      if (designs.length === 0) {
        alert("Please upload at least one design.");
        return;
      }
      dtf_add_to_cart.classList.remove("shine");
      dtf_add_to_cart.disabled = true;
      dtf_add_to_cart.classList.add("loading");
      dtf_add_to_cart.innerHTML = DTF_PCS_CART_LOADING_HTML;

      const calculatorId = "79506c6905604";
      const productId = 7661297827888;

      const cartItems = [];

      try {
        for (const design of designs) {
          const block = design.sizeBlock;
          if (!block) continue;
          const file = design.file;
      if (!file) {
            alert("Missing file for one of the designs.");
            continue;
          }

          const props = {
            Fabric: design.fabric,
            Width: block.width.toFixed(2),
            Height: block.height.toFixed(2),
            Quantity: block.qty.toString(),
            Price: block.total.toFixed(2),
            "Upload Image": file.name,
          };

          const payload = {
            calculatorId,
            productId,
            properties: props,
          };

          const res = await fetch(
            "https://api.custompricecalculator.com/api/v1/variant",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(payload),
            }
          );

          const json = await res.json();
          const variantId =
            typeof json === "string" ? json : json?.variantId || json?.id;
          if (!variantId) throw new Error("Invalid variantId received");

          const formData = new FormData();
          formData.append("id", variantId);
          formData.append("quantity", 1);
          Object.entries(props).forEach(([k, v]) => {
            formData.append(`properties[${k}]`, v);
          });
            formData.append("properties[Upload Image]", file);

          const cartAddRes = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
          });
          const cartAddJson = await cartAddRes.json();
          cartItems.push(cartAddJson);
        }

        await new Promise((r) => setTimeout(r, 300));

        const timestamp = Date.now();
        const html = await fetch(
          `/cart?section_id=mini-cart&t=${timestamp}`
        ).then((r) => r.text());
        const fake = document.createElement("div");
        fake.innerHTML = html;
        const miniCartHTML = fake.querySelector("cart-drawer")?.outerHTML;
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && miniCartHTML) {
          cartDrawer.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: { sections: { "mini-cart": miniCartHTML } },
                openMiniCart: true,
              },
            })
          );
        }

        setTimeout(() => {
          if (!cartDrawer) return;
          const lineItems = cartDrawer.querySelectorAll("line-item");
          lineItems.forEach((lineItem) => {
            const desktopPriceContainer = lineItem.querySelector(
              ".line-item__price-list-container .price"
            );
            const mobilePriceContainer = lineItem.querySelector(
              ".product-item-meta__price-list-container .price-list.hidden-tablet-and-up .price"
            );
            if (!desktopPriceContainer && !mobilePriceContainer) return;
            const priceText = (
              desktopPriceContainer || mobilePriceContainer
            ).textContent.trim();
            const isFree = /Free|\$0\.00/.test(priceText);
            let variantId;
            const productLink = lineItem.querySelector("a[href*='?variant=']");
            if (productLink?.href.includes("variant=")) {
              variantId = productLink.href.split("variant=")[1].split("&")[0];
            }
            if (!variantId) {
              const removeBtn = lineItem.querySelector(
                "a[href*='/cart/change?id=']"
              );
              const removeHref = removeBtn?.getAttribute("href") || "";
              const match = removeHref.match(/id=(\d+):/);
              variantId = match?.[1];
            }
            if (isFree && variantId) {
              const matchingItem = cartItems.find(
                (item) => String(item.id) === variantId
              );
              if (matchingItem) {
                const correctPrice = (matchingItem.price / 100).toFixed(2);
                const imageWrapper = lineItem.querySelector(
                  ".line-item__image-wrapper"
                );
                const productThumbnail = imageWrapper.querySelector(
                  "img.line-item__image"
                );
                const productTitle = lineItem.querySelector(
                  ".product-item-meta .product-item-meta__title"
                );
                if (!productThumbnail) {
                  const imgSrc = document.querySelector(
                    ".product__thumbnail-item .product__thumbnail img"
                  )?.src;
                  if (imgSrc) {
                    imageWrapper.innerHTML += `
                      <img src="${imgSrc}" alt="" srcset="${imgSrc}" width="1024" height="1024" loading="lazy" sizes="(max-width: 740px) 80px, 92px" class="line-item__image">
                    `;
                  }
                }
                if (productTitle && productTitle.textContent.trim() === "") {
                  const metaTitle = document.querySelector(
                    ".product__info .product-meta__title"
                  );
                  if (metaTitle) {
                    productTitle.textContent = metaTitle.textContent;
                  }
                }
                const updatedPriceHTML = `
                  <span class="visually-hidden">Sale price</span>
                  $${correctPrice}
                `;
                if (desktopPriceContainer) {
                  desktopPriceContainer.innerHTML = updatedPriceHTML;
                }
                if (mobilePriceContainer) {
                  mobilePriceContainer.innerHTML = updatedPriceHTML;
                }
              }
            }
          });
        }, 500);

        setTimeout(async () => {
          const cartJson = await fetch("/cart.js").then((res) => res.json());
          const cartCountEl = document.querySelector("cart-count");
          if (cartCountEl) cartCountEl.textContent = cartJson.item_count;
        }, 300);
      } catch (err) {
        console.error("🚨 Error during cart add:", err);
        alert("Something went wrong while adding items to the cart.");
      } finally {
        dtf_add_to_cart.disabled = false;
        dtf_add_to_cart.classList.remove("loading");
        dtf_add_to_cart.innerHTML = DTF_PCS_CART_BTN_HTML;
        setTimeout(playCartButtonShine, 400);
      }
    });
  }

  // ============================================================
  // COLOR PICKER & MOCKUP COLORS
  // ============================================================
  function colorInject() {
    const colorBoxes = document.querySelectorAll(
      "#dtf-color-selector span:not(.custom-color-trigger)"
    );
    const customColorTrigger = document.querySelector("#dtf-color-selector .custom-color-trigger");
    const colorPickerContainer = document.getElementById("color-picker-container");
    if (!colorBoxes.length) return;

    const applyColor = (color) => {
      document.querySelectorAll(".mockup-panel").forEach((p) => {
        p.style.background = color;
      });
    };

    const colorPicker = new iro.ColorPicker("#color-picker", {
      width: 180,
      color: "#ffffff",
      layoutDirection: "horizontal",
      display: "flex",
      layout: [
        { component: iro.ui.Box },
        { component: iro.ui.Slider, options: { sliderType: "hue" } },
      ],
    });

    colorBoxes.forEach((box) => {
      box.style.backgroundColor = box.getAttribute("data-color");
      box.addEventListener("click", function () {
    document
          .querySelectorAll("#dtf-color-selector span")
          .forEach((item) => item.classList.remove("active"));
        this.classList.add("active");
        applyColor(this.getAttribute("data-color"));
        colorPickerContainer.classList.add("hidden");
      });
    });

    customColorTrigger.addEventListener("click", function (e) {
      e.stopPropagation();
      colorBoxes.forEach((item) => item.classList.remove("active"));
      this.classList.add("active");
      colorPickerContainer.classList.remove("hidden");
      applyColor(colorPicker.color.hexString);
      this.dataset.selectedColor = colorPicker.color.hexString;
      this.dataset.color = colorPicker.color.hexString;
    });

    colorPicker.on("color:change", function (color) {
      applyColor(color.hexString);
      customColorTrigger.style.backgroundColor = color.hexString;
      customColorTrigger.dataset.selectedColor = color.hexString;
      customColorTrigger.dataset.color = color.hexString;
    });

    document.addEventListener("click", function (e) {
      if (
        !colorPickerContainer.contains(e.target) &&
        e.target !== customColorTrigger
      ) {
        colorPickerContainer.classList.add("hidden");
            }
          });
        }

  // ============================================================
  // FINGERPRINT (used by AI image generation)
  // ============================================================
  async function getFingerprint() {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx.textBaseline = "top";
    ctx.font = "16px Arial";
    ctx.fillText(":unicorn_face: Vulgrco Fingerprint!", 2, 2);
    const canvasData = canvas.toDataURL();

    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioCtx.createOscillator();
    const analyser = audioCtx.createAnalyser();
    const gain = audioCtx.createGain();
    const script = audioCtx.createScriptProcessor(256, 1, 1);
    oscillator.type = "triangle";
    oscillator.frequency.value = 10000;
    gain.gain.value = 0;
    oscillator.connect(gain);
    gain.connect(analyser);
    analyser.connect(script);
    script.connect(audioCtx.destination);
    oscillator.start(0);

    const audioFingerprint = await new Promise((resolve) => {
      script.onaudioprocess = function () {
        const freqData = new Float32Array(analyser.frequencyBinCount);
        analyser.getFloatFrequencyData(freqData);
        resolve(freqData.slice(0, 10).join(","));
        oscillator.stop();
        script.disconnect();
      };
    });

    const raw = [
      navigator.platform,
      screen.width,
      screen.height,
      navigator.hardwareConcurrency,
      navigator.deviceMemory || 0,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      canvasData,
      audioFingerprint,
    ].join("|");
    const data = new TextEncoder().encode(raw);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  }

  async function checkSession() {
    try {
      const res = await fetch("https://ai.vulgrco.com/check_session", {
        method: "GET",
        credentials: "include",
      });
      return res.ok;
    } catch {
      return false;
    }
  }

  async function getSession() {
    await fetch("https://ai.vulgrco.com/get_session", {
      method: "GET",
          credentials: "include",
        });
  }

  // ============================================================
  // AI IMAGE GENERATION (clicking a generated image creates a new design)
  // ============================================================
  const vulgrOpenButton = document.getElementById("vulgrOpenButton");
  const vulgrModalWindow = document.getElementById("vulgrModalWindow");
  const vulgrGenerateButton = document.getElementById("vulgrGenerateButton");
  const vulgrPromptInput = document.getElementById("vulgrPromptInput");
  const vulgrStatusMessage = document.getElementById("vulgrStatusMessage");
  const vulgrModalCloseButton = document.getElementById(
    "vulgrModalCloseButton"
  );
  const vulgrResultsContainer = document.querySelector(
    ".vulgr-results-container"
  );
  const loadingLotties = `<div class="lottie-wrapper">
    <dotlottie-player src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/generating-images.lottie" background="transparent" speed="1" loop="" autoplay=""></dotlottie-player>
        </div>
        <div class="lottie-wrapper">
    <dotlottie-player src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/generating-images.lottie" background="transparent" speed="1" loop="" autoplay=""></dotlottie-player>
        </div>
        <div class="lottie-wrapper">
    <dotlottie-player src="https://cdn.shopify.com/s/files/1/0582/5400/0176/files/generating-images.lottie" background="transparent" speed="1" loop="" autoplay=""></dotlottie-player>
        </div>`;

  function closeVulgrModal() {
    vulgrModalWindow.style.display = "none";
    vulgrPromptInput.value = "";
    vulgrResultsContainer.querySelectorAll("img").forEach((el) => el.remove());
    vulgrResultsContainer.innerHTML = loadingLotties;
    vulgrResultsContainer.style.display = "none";
    document.querySelector(".vulgr-prompt-example").style.display = "block";
    document.querySelector(".vulgr-output-example").style.display = "block";
    vulgrStatusMessage.textContent = "";
    vulgrStatusMessage.style.display = "none";
  }

  if (vulgrOpenButton)
    vulgrOpenButton.onclick = () =>
      (vulgrModalWindow.style.display = "flex");
  if (vulgrModalCloseButton)
  vulgrModalCloseButton.onclick = () => closeVulgrModal();

  async function checkJobStatus(jobId) {
    const res = await fetch(`https://ai.vulgrco.com/status/${jobId}`, {
      method: "GET",
      headers: { "X-API-KEY": "kaka" },
      credentials: "include",
    });
    if (!res.ok) return null;
    return await res.json();
  }

  async function waitForImageJob(jobId) {
    vulgrStatusMessage.style.display = "block";
    vulgrModalCloseButton.disabled = true;

    const displayed = new Set();
    const dotlottieElements = document.querySelectorAll(
      ".vulgr-results-container .lottie-wrapper"
    );

    const poll = async () => {
      const status = await checkJobStatus(jobId);
      if (!status) return;
      if (status.status === "failed") {
        vulgrStatusMessage.textContent = "❌ Image generation failed.";
        return;
      }

      const images = status.result?.images || [];
      for (let i = 0; i < images.length; i++) {
        if (displayed.has(i)) continue;
        const imageData = images[i];

        const img = document.createElement("img");
        img.src = imageData.base64;
        img.alt = `Generated Image ${i + 1}`;
        img.className = "vulgr-result-image";

        img.addEventListener("click", async () => {
          const blob = await (await fetch(imageData.base64)).blob();
          const file = new File([blob], `ai_image_${Date.now()}_${i + 1}.png`, {
            type: blob.type,
          });
          await createDesign(file);
          closeVulgrModal();
        });

        if (dotlottieElements[i]) dotlottieElements[i].replaceWith(img);
        displayed.add(i);
      }

      if (status.status !== "finished" || displayed.size < 3) {
        setTimeout(poll, 1000);
      } else {
        vulgrStatusMessage.style.display = "none";
        vulgrModalCloseButton.disabled = false;
      }
    };
    poll();
  }

  async function generateAIImage(prompt = "A cute cat dancing", model = "juggernaut") {
    const fingerprint = await getFingerprint();
    document.querySelector(".vulgr-prompt-example").style.display = "none";
    document.querySelector(".vulgr-output-example").style.display = "none";

    try {
      const res = await fetch("https://ai.vulgrco.com/generateForFrontEnd", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": "kaka",
          "X-FINGERPRINT": fingerprint,
        },
        credentials: "include",
        body: JSON.stringify({ prompt, model }),
      });
      const data = await res.json();
      document
        .querySelector(".vulgr-results-container")
        .querySelectorAll("img, input[type='file']")
        .forEach((el) => el.remove());
      if (!res.ok) {
        const errorMessage = data?.error || "❌ Generation failed.";
        vulgrStatusMessage.textContent = errorMessage;
        vulgrStatusMessage.style.display = "block";
        return;
      }
      if (data.job_id) waitForImageJob(data.job_id);
    } catch (err) {
      vulgrStatusMessage.textContent = "❌ Error during image generation.";
      vulgrStatusMessage.style.display = "block";
    }
  }

  if (vulgrGenerateButton) {
  vulgrGenerateButton.onclick = async () => {
    const prompt = vulgrPromptInput.value.trim();
    const vulgrPromptContainer = document.querySelector(
      ".vulgr-prompt-container"
    );
    if (!prompt) return vulgrPromptContainer.classList.add("error");
    vulgrStatusMessage.textContent = "Generating Images...";
    const modelSelect = document.getElementById("vulgrModelSelection");
    const selectedModel = modelSelect.value;
    vulgrResultsContainer.style.display = "grid";
    vulgrResultsContainer.innerHTML = loadingLotties;
    vulgrPromptContainer.classList.remove("error");
      await generateAIImage(prompt, selectedModel);
  };
  }

  // ============================================================
  // DISCOUNT GUIDE MODAL
  // ============================================================
  function discountGuideModal() {
    const discountGuideModalEl = document.getElementById("discountGuideModal");
    const discountGuideCloseBtn = document.getElementById(
      "discountGuideCloseBtn"
    );
    if (!discountGuideModalEl || !discountGuideCloseBtn) return;

    document.addEventListener("click", (e) => {
      if (e.target.closest(".vd-guide-link")) {
        discountGuideModalEl.style.display = "flex";
      }
    });
    discountGuideCloseBtn.onclick = () =>
      (discountGuideModalEl.style.display = "none");
  }

  // ============================================================
  // INIT
  // ============================================================
  setupInitialUpload();
  setupAddAnotherDesign();
  discountGuideModal();
  updateShippingBar(0);
  updateBuyBarSummary(0);
  setupCartButtonShine();

  function bindCalculatorReady() {
    document
      .getElementById("artwork-box")
      .classList.remove("loading--scripts");
      const fileInput = document.querySelector(".calc-prop.cpc-file-upload");
    if (fileInput)
      fileInput.setAttribute(
        "accept",
        ".jpg,.jpeg,.png,.webp,.avif,.tiff,.svg"
      );
    addToCartEvent();
  }

  try {
    const hasSession = await checkSession();
    if (!hasSession) await getSession();
  } catch (err) {
    console.warn("⚠️ Backend not reachable. Proceeding without session.");
  }

  // If calculator is already in the DOM, bind immediately; otherwise observe.
  if (document.querySelector("#calculator")) {
    bindCalculatorReady();
  } else {
    const observer = new MutationObserver(() => {
      if (document.querySelector("#calculator")) {
        observer.disconnect();
        bindCalculatorReady();
      }
    });
  observer.observe(document.body, { childList: true, subtree: true });
  }
});
